export default __webpack_public_path__ + "static/media/Fenogreco.6762f90d.jpeg";